import agent from 'local/test/agent';
import { waitForAgentReady } from 'local/test/agentReady';
import testIpType from 'local/test/testIpType';

/**
 * When the client is ready, it should send a clientReady event to the agent.
 * The agent will then respond with an agentReady event.
 *
 * Important: The agent has 10 seconds to respond with agentReady. If it doesn't,
 * the client can assume that the agent is not working and should handle it
 * accordingly.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#instructions-that-the-agent-should-be-able-to-receive}
 */
export default function connect(m) {
	testIpType(m).finally(() => {
		agent.send({ method: 'clientReady' });

		waitForAgentReady(() => {
			m.dispatch('error', {
				errno: 'A04',
				error: 'Agent did not respond',
			});
		});
	});
}
